"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cowGetTradeTxs = void 0;
const api_1 = require("../../../api");
const constants_1 = require("../utils/constants");
const cowService_1 = require("../utils/cowService");
async function cowGetTradeTxs(deps, input) {
    try {
        const getOrdersResponse = await cowService_1.cowService.get(`${deps.apiUrl}/v1/orders/${input.tradeId}`);
        const { data: { status }, } = getOrdersResponse;
        if (status !== constants_1.ORDER_STATUS_FULFILLED) {
            return {
                sellTxid: '',
            };
        }
        const getTradesResponse = await cowService_1.cowService.get(`${deps.apiUrl}/v1/trades/?orderUid=${input.tradeId}`);
        return {
            sellTxid: input.tradeId,
            buyTxid: getTradesResponse.data[0].txHash,
        };
    }
    catch (e) {
        if (e instanceof api_1.SwapError)
            throw e;
        throw new api_1.SwapError('[cowGetTradeTxs]', {
            cause: e,
            code: api_1.SwapErrorTypes.GET_TRADE_TXS_FAILED,
        });
    }
}
exports.cowGetTradeTxs = cowGetTradeTxs;
